import {
  CheckBadgeIcon,
  Cog6ToothIcon,
  DocumentChartBarIcon,
  EnvelopeIcon,
  GiftIcon,
  HeartIcon,
  HomeIcon,
  LinkIcon,
  RectangleStackIcon,
  UserGroupIcon,
} from "@";

export const sidebarGroups = [
  // Group 1: لوحة التحكم
  {
    id: "dashboard",
    name: "لوحة التحكم",
    icon: <HomeIcon className="sidebar-li-icon" />,
    canShow: "statistics",
    urls: [
      { name: "إحصاءات وبيانات", url: "/statistics", canShow: "statistics" },
      {
        name: "الاحصائيات المتقدمة",
        url: "/advanced-statistics",
        canShow: "statistics",
      },
    ],
  },
  // Group 2: التبرعات
  {
    id: "donations",
    name: "التبرعات",
    icon: <HeartIcon className="sidebar-li-icon" />,
    canShow: "viewProjects,editProjects,viewDonations,abandonedCarts",
    urls: [
      {
        name: "فرص التبرع",
        url: "/projects",
        canShow: "viewProjects,editProjects",
      },
      { name: "قائمة التبرعات", url: "/donations", canShow: "viewDonations" },
      {
        name: "الاستقطاعات",
        url: "/recurring-payment",
        canShow: "viewDonations",
      },
      { name: "السلات المتروكة", url: "/carts", canShow: "abandonedCarts" },
    ],
  },
  // Group 3: التقارير
  {
    id: "reports",
    name: "التقارير",
    icon: <DocumentChartBarIcon className="sidebar-li-icon" />,
    canShow: "financialSupervisorReport,requiredReports,nationalCenterReport",
    urls: [
      {
        name: "التقرير المالي",
        url: "/reports/financial",
        canShow: "financialSupervisorReport",
      },
      {
        name: "تقرير التبرعات التفصيلي",
        url: "/reports/detailed",
        canShow: "requiredReports",
      },
      {
        name: "تقارير الجمع للمركز الوطني",
        url: "/reports/national-center",
        canShow: "nationalCenterReport",
      },
    ],
  },
  // Group 4: المتبرعون
  {
    id: "donors",
    name: "المتبرعون",
    icon: <UserGroupIcon className="sidebar-li-icon" />,
    canShow: "donors,ratings,customerCampaigns",
    urls: [
      { name: "المتبرعين", url: "/donors", canShow: "donors" },
      {
        name: "حملات العملاء",
        url: "/customers-campaigns",
        canShow: "customerCampaigns",
      },
      { name: "التقيمات", url: "/ratings", canShow: "ratings" },
    ],
  },
  // Group 5: الإهداءات
  {
    id: "gifts",
    name: "الإهداءات",
    icon: <GiftIcon className="sidebar-li-icon" />,
    canShow: "showGiftProject,editGiftProject",
    urls: [
      { name: "الإهداءات الحالية", url: "/gifting" },
      {
        name: "إضافة إهداء",
        url: "/giftProjects/create",
        canShow: "editGiftProject",
      },
      {
        name: "بيانات الإهداءات",
        url: "/giftProjects/orders",
        canShow: "showGiftProject",
      },
    ],
  },
  // Group 6: التسويق والإعلانات
  {
    id: "marketing",
    name: "التسويق والإعلانات",
    icon: <LinkIcon className="sidebar-li-icon" />,
    canShow:
      "advertisementCoordinators,advertisementLinks,coordinatorDonations,whatsappCampaign",
    urls: [
      {
        name: "المنسقين",
        url: "/affiliateUsers",
        canShow: "advertisementCoordinators",
      },
      {
        name: "الروابط",
        url: "/affiliateLinks",
        canShow: "advertisementLinks",
      },
      {
        name: "روابط المنسقين",
        url: "/affiliateDonates",
        canShow: "coordinatorDonations",
      },
      {
        name: "حملات WhatsApp",
        url: "/whatsapp-campaign",
        canShow: "whatsappCampaign",
      },
    ],
  },
  // Group 7: المراسلات
  {
    id: "messages",
    name: "المراسلات",
    icon: <EnvelopeIcon className="sidebar-li-icon" />,
    canShow: "sendMessage",
    urls: [
      { name: "إرسال رسالة جماعية", url: "/send-multiple" },
      { name: "إرسال رسالة مخصصة", url: "/send-single" },
      { name: "الرسائل المؤتمتة", url: "/automated" },
      { name: "المراسلات السابقة", url: "/messages" },
      { name: "رصيد نقاط المتجر", url: "/sms-balance" },
    ],
  },
  // Group 9: العمليات والمتابعة
  {
    id: "operations",
    name: "العمليات والمتابعة",
    icon: <CheckBadgeIcon className="sidebar-li-icon" />,
    canShow:
      "canDoProjectVerification,verificationManager,viewComplaintsAndSuggestions",
    urls: [
      {
        name: "إحصائيات التوثيق",
        url: "/verifications-statistics",
        canShow: "verificationManager",
      },
      {
        name: "المناديب",
        url: "/verifications-drivers",
        canShow: "canDoProjectVerification,verificationManager",
      },
      {
        name: "إسناد الطلبات",
        url: "/verifications-donations",
        canShow: "canDoProjectVerification,verificationManager",
      },
      {
        name: "إدارة الجودة",
        url: "/verifications-verify",
        canShow: "canDoProjectVerification,verificationManager",
      },

      {
        name: "الشكاوى والمقترحات",
        url: "/contact-messages",
        canShow: "viewComplaintsAndSuggestions",
      },
    ],
  },
  // Group 8: الموقع الإلكتروني
  {
    id: "website",
    name: "الموقع الإلكتروني",
    icon: <RectangleStackIcon className="sidebar-li-icon" />,
    canShow:
      "viewMainBanner,editMainBanner,viewSitePages,editSitePages,homepageSettings,arrangeHomepageItems,platformStatistics,ourPartners,popups,viewThemes,editThemes,publishThemes",
    urls: [
      {
        name: "البانر الرئيسي",
        url: "/website/carousel",
        canShow: "viewMainBanner,editMainBanner",
      },
      {
        name: "الثيمات",
        url: "/website/themes",
        canShow: "viewThemes,editThemes,publishThemes",
      },
      {
        name: "صفحات الهبوط",
        url: "/website/landing-pages",
        canShow: "viewSitePages,editSitePages",
      },
      // {
      //   name: "صفحات الموقع الالكترونى",
      //   url: "/website/pages",
      //   canShow: "viewSitePages,editSitePages",
      // },
      // {
      //   name: "صفحة التبرع السريع",
      //   url: "/website/fast-donation",
      //   canShow: "viewSitePages,editSitePages",
      // },
      {
        name: " بانر الصفحة الرئيسية",
        url: "/website/home-page-banner",
        canShow: "homepageSettings",
      },
      // {
      //   name: " ترتيب عناصر القائمة",
      //   url: "/website/order-home-section",
      //   canShow: "arrangeHomepageItems",
      // },
      { name: "شركاؤنا", url: "/website/our-partners", canShow: "ourPartners" },
      // {
      //   name: "النوافذ المنبثقة",
      //   url: "/website/ads-popup",
      //   canShow: "popups",
      // },
    ],
  },
  // Group 10: الإعدادات
  {
    id: "settings",
    name: "الإعدادات",
    icon: <Cog6ToothIcon className="sidebar-li-icon" />,
    canShow:
      "associationData,editAssociationData,serviceLinkSettings,generalSettings,permissions,editSmsMessage,importData,showLogs",
    urls: [
      {
        name: "نظرة عامة",
        url: "/all-settings",
        canShow:
          "serviceLinkSettings,generalSettings,permissions,editSmsMessage",
      },

      // Sub-section 1: store / workspace
      { header: true, name: "المتجر" },
      {
        name: "الإعدادات العامة",
        url: "/settings-general",
        canShow: "generalSettings",
      },
      {
        name: "عن الجمعية",
        url: "/association-manager",
        canShow: "associationData,editAssociationData",
      },
      {
        name: "موظفي المتجر",
        url: "/settings-users",
        canShow: "permissions",
      },

      // Sub-section 2: integrations
      { header: true, name: "التكاملات" },
      // {
      //   name: "التكاملات الخارجية",
      //   url: "/settings-integrations",
      //   canShow: "serviceLinkSettings",
      // },
      {
        name: "ربط الخدمات",
        url: "/settings-services-connection",
        canShow: "serviceLinkSettings",
      },
      {
        name: "التحكم في الرسائل",
        url: "/settings-control",
        canShow: "editSmsMessage",
      },

      // Sub-section 3: data & records
      { header: true, name: "البيانات والسجل" },
      {
        name: "التصنيفات",
        url: "/classifications",
        canShow: "editAssociationData",
      },
      {
        name: "استيراد البيانات",
        url: "/import-data",
        canShow: "importData",
      },
      {
        name: "سجل الأحداث",
        url: "/logs",
        canShow: "showLogs",
      },
    ],
  },
];
